// Missing opt-in preserves percentage-only studies saved before horizon support.
// Keep this out of shared/default merges applied when opening existing projects.
export const NEW_HORIZON_SETTINGS = { horizonEnabled: true, horizonInPercentage: true };

export function horizonShadingEnabled(config) {
  const po = config?.panelOrientation || {};
  return po.horizonEnabled !== false &&
    (config?.pvLosses?.dc?.shadingMode !== 'percentage' || po.horizonInPercentage === true);
}

export function withHorizonShading(config, enabled) {
  return { ...config, panelOrientation: { ...config?.panelOrientation,
    horizonEnabled: Boolean(enabled), horizonInPercentage: true } };
}
